<template>
  <div>
    <ul class="grid-files" id="data-files" v-loading="loading">
      <span class="d-flex flex-wrap" v-if="haveFolder()">
        <li class="file" v-for="(folder,index) in folders" @dblclick="openFolder(folder.id,folder.media_type_id)" v-bind:key="index" title="ダブルタップして開きます">
        <div class="file-content mypage__files">
          <div class="mypage__thumbnail">
            <div class="gridFiles-mb">
              <img v-if="folder.icon_url" :src="folder.icon_url" alt="" class="mypage__files__image">
              <img v-else src="@/assets/images/avt-exp.svg" alt="" class="mypage__files__image">
              <span class="folder-total-1" v-if="isFolder(folder.media_type_id)">{{folder.total_files}}</span>
              <div class="mypage__kindFile">
                <div class="mypage__iconList" v-if="isImageAndVideo(folder.media_type_id)">
                  <img src="@img/icon/icon-image.svg" alt="" v-if="isImage(folder.media_type_id)">
                  <img src="@img/icon/icon-video.svg" alt="" v-if="isVideo(folder.media_type_id)">
                </div>
              </div>
              <div class="mypage__kindFile mypage__iconList" v-if="isVideo(folder.media_type_id)">
                <img src="@img/icon/icon-video.svg" alt="">
              </div>
              <div class="mypage__fileFavorite mypage__iconList action-hover wider-click">
                <b-dropdown class="dropdownAction" variant="link"  toggle-class="text-decoration-none" no-caret>
                  <template v-slot:button-content>
                    <i class="icon-i-dot"></i>
                  </template>
                  <b-dropdown-item @click="openFolder(folder.id,folder.media_type_id)">
                    <i class="icon-i-eyes"></i>
                    <span>開く</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="showModalMoveTo(folder.id,folder.folder_parent_id)" v-if="isFile(folder.media_type_id)">
                    <svg id="Group_10221" data-name="Group 10221" xmlns="http://www.w3.org/2000/svg" width="17.616" height="17.615" viewBox="0 0 17.616 17.615">
                      <g id="Group_10220" data-name="Group 10220">
                        <path id="Path_10174" data-name="Path 10174" d="M17.508,8.548,14.939,5.979a.367.367,0,0,0-.626.259v1.1a.367.367,0,0,0,.108.259l.475.475H9.541V2.721l.475.475a.367.367,0,0,0,.259.108h1.1a.367.367,0,0,0,.259-.626L9.067.107a.367.367,0,0,0-.519,0L5.979,2.676a.367.367,0,0,0,.259.626h1.1A.367.367,0,0,0,7.6,3.2l.475-.475V8.073H2.721L3.2,7.6A.367.367,0,0,0,3.3,7.339v-1.1a.367.367,0,0,0-.626-.259L.107,8.548a.367.367,0,0,0,0,.519l2.569,2.569a.367.367,0,0,0,.259.108.362.362,0,0,0,.14-.028.367.367,0,0,0,.226-.339v-1.1a.367.367,0,0,0-.108-.259l-.475-.475H8.073v5.353L7.6,14.42a.367.367,0,0,0-.259-.108h-1.1a.367.367,0,0,0-.259.626l2.569,2.569a.367.367,0,0,0,.519,0l2.569-2.569a.367.367,0,0,0-.259-.626h-1.1a.367.367,0,0,0-.259.108l-.475.475V9.541h5.353l-.475.475a.367.367,0,0,0-.108.259v1.1a.367.367,0,0,0,.226.339.363.363,0,0,0,.14.028.367.367,0,0,0,.259-.108l2.569-2.569A.367.367,0,0,0,17.508,8.548Z" transform="translate(0 0)" fill="#333"/>
                      </g>
                    </svg>
                    <span class="ml-12">移動</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="copyFile(folder.id)" v-if="isFile(folder.media_type_id)">
                    <svg id="Group_10216" data-name="Group 10216" xmlns="http://www.w3.org/2000/svg" width="15.805" height="15.805" viewBox="0 0 15.805 15.805">
                      <path id="Path_10171" data-name="Path 10171" d="M15.558,3.634a.817.817,0,0,0-.6-.247H11.289a2.243,2.243,0,0,0-1.129.353V.847a.816.816,0,0,0-.247-.6A.817.817,0,0,0,9.314,0H5.645a2.037,2.037,0,0,0-.776.176A2.053,2.053,0,0,0,4.2.6L.6,4.2a2.052,2.052,0,0,0-.423.67A2.037,2.037,0,0,0,0,5.645v5.927a.816.816,0,0,0,.247.6.816.816,0,0,0,.6.247h4.8v2.54a.843.843,0,0,0,.847.847h8.467a.843.843,0,0,0,.847-.847V4.234A.816.816,0,0,0,15.558,3.634Zm-5.4,1.632V7.9H7.523ZM4.516,1.879V4.516H1.879ZM6.244,7.585a2.052,2.052,0,0,0-.423.67,2.037,2.037,0,0,0-.176.776v2.258H1.129V5.645H4.8A.843.843,0,0,0,5.645,4.8V1.129H9.032V4.8Zm8.432,7.091h-7.9V9.031h3.669a.843.843,0,0,0,.847-.847V4.516h3.387V14.676h0Z" transform="translate(0)" fill="#333"/>
                    </svg>
                    <span class="ml-12">コピー</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="showModalRename(folder.id,folder.media_type_id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14.594" height="14.592" viewBox="0 0 14.594 14.592">
                      <path id="Union_67" data-name="Union 67" d="M1.542,14.392A1.542,1.542,0,0,1,0,12.851V2.569A1.542,1.542,0,0,1,1.542,1.028H7.711a.514.514,0,0,1,0,1.028H1.542a.513.513,0,0,0-.514.513V12.851a.513.513,0,0,0,.514.513h9.252a.514.514,0,0,0,.515-.513V7.71a.514.514,0,1,1,1.028,0v5.141a1.542,1.542,0,0,1-1.542,1.541Zm1.893-3.11a.512.512,0,0,1-.324-.65L4.139,7.548a.515.515,0,0,1,.124-.2L11.034.576a1.968,1.968,0,1,1,2.783,2.783L7.046,10.13a.511.511,0,0,1-.2.124L3.761,11.282a.506.506,0,0,1-.163.027A.517.517,0,0,1,3.436,11.282Zm8.325-9.976L5.075,7.988,4.412,9.982l2-.667L13.09,2.632a.939.939,0,0,0-1.329-1.327Z" transform="translate(0.1 0.1)" fill="#333" stroke="#333" stroke-width="0.2"/>
                    </svg>
                    <span class="ml-12" v-if="isFile(folder.media_type_id)">編集</span>
                    <span class="ml-12" v-else>名前変更</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="showModalDelete(folder.id,folder.media_type_id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.467" height="16.574" viewBox="0 0 13.467 16.574">
                      <path id="Union_68" data-name="Union 68" d="M2.8,16.574a1.552,1.552,0,0,1-1.553-1.48L.8,5.7H.518A.519.519,0,0,1,0,5.18V3.367a1.3,1.3,0,0,1,1.3-1.3H4.144V1.554A1.556,1.556,0,0,1,5.7,0H7.77A1.556,1.556,0,0,1,9.323,1.554v.517h2.849a1.3,1.3,0,0,1,1.294,1.3V5.18a.518.518,0,0,1-.517.518h-.284l-.447,9.4a1.551,1.551,0,0,1-1.552,1.48Zm-.517-1.529a.517.517,0,0,0,.517.493h7.866a.516.516,0,0,0,.517-.493L11.629,5.7H1.838ZM1.036,3.367v1.3H12.431v-1.3a.259.259,0,0,0-.258-.259H1.3A.259.259,0,0,0,1.036,3.367ZM5.18,1.554v.517H8.287V1.554a.518.518,0,0,0-.517-.518H5.7A.519.519,0,0,0,5.18,1.554ZM8.806,13.985V7.251a.518.518,0,0,1,1.036,0v6.734a.518.518,0,0,1-1.036,0Zm-2.59,0V7.251a.518.518,0,0,1,1.036,0v6.734a.518.518,0,0,1-1.036,0Zm-2.59,0V7.251a.518.518,0,0,1,1.036,0v6.734a.518.518,0,0,1-1.036,0Z" fill="#333"/>
                    </svg>
                    <span class="ml-12">削除</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="showModalDetail(folder.id,folder.media_type_id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14.2" height="16.2" viewBox="0 0 14.2 16.2">
                      <path id="Path_10175" data-name="Path 10175" d="M14.344-11.422q-.266-.359-.617-.758t-.742-.8q-.406-.391-.8-.742t-.758-.617a4.129,4.129,0,0,0-.93-.547A1.667,1.667,0,0,0,10-15H2.25a1.2,1.2,0,0,0-.883.367A1.2,1.2,0,0,0,1-13.75V-.25a1.2,1.2,0,0,0,.367.883A1.2,1.2,0,0,0,2.25,1h11.5a1.2,1.2,0,0,0,.883-.367A1.2,1.2,0,0,0,15-.25V-10a1.667,1.667,0,0,0-.109-.492A4.129,4.129,0,0,0,14.344-11.422Zm-2.078-.844q.359.359.648.68t.492.586H11v-2.406q.266.2.586.492T12.266-12.266ZM14-.25a.243.243,0,0,1-.07.18.243.243,0,0,1-.18.07H2.25a.243.243,0,0,1-.18-.07A.243.243,0,0,1,2-.25v-13.5a.243.243,0,0,1,.07-.18A.243.243,0,0,1,2.25-14H10v3.5a.481.481,0,0,0,.148.352A.481.481,0,0,0,10.5-10H14ZM11.5-2h-7a.481.481,0,0,1-.352-.148A.481.481,0,0,1,4-2.5a.481.481,0,0,1,.148-.352A.481.481,0,0,1,4.5-3h7a.481.481,0,0,1,.352.148A.481.481,0,0,1,12-2.5a.481.481,0,0,1-.148.352A.481.481,0,0,1,11.5-2Zm0-2h-7a.481.481,0,0,1-.352-.148A.481.481,0,0,1,4-4.5a.481.481,0,0,1,.148-.352A.481.481,0,0,1,4.5-5h7a.481.481,0,0,1,.352.148A.481.481,0,0,1,12-4.5a.481.481,0,0,1-.148.352A.481.481,0,0,1,11.5-4Zm0-2h-7a.481.481,0,0,1-.352-.148A.481.481,0,0,1,4-6.5a.481.481,0,0,1,.148-.352A.481.481,0,0,1,4.5-7h7a.481.481,0,0,1,.352.148A.481.481,0,0,1,12-6.5a.481.481,0,0,1-.148.352A.481.481,0,0,1,11.5-6Z" transform="translate(-0.9 15.1)" fill="#333" stroke="#313131" stroke-width="0.2"/>
                    </svg>
                    <span class="ml-12">詳細表示</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="mypage__iconList mypage__file-action" v-if="folder.like_action">
              <i class="icon-i-like"></i>
            </div>
          </div>
          <div class="mypage__files__title">{{truncate(folder.name,5,'...')}}</div>
          <div class="mypage__files__datetime">{{dateFormat(folder.updated_time)}}</div>
        </div>
      </li>
      </span>
      <div v-if="isSearch && !loading && !showNoData()" class="text-center">
        <b-link class="btn btn-rounder btn-primary btn-contact w-100 btn-basic my-4 mx-auto" :to="{name: 'admin_folders', params: {id: this.$route.params.id, folder_id: 0}}">一覧に戻る</b-link>
      </div>
      <div class="d-flex justify-content-center align-items-center no-result" v-if="showNoData()">
        <img src="@img/icon/no-result.svg" class="img-no-result" />
        <div class="no-result-text" v-if="folderIsSearch()">データなし</div>
        <div class="no-result-text" v-else>検索結果がありませんでした。</div>
        <div class="no-result-text back-to-files">
          <b-link :to="{name: 'admin_folders', params: {id: this.$route.params.id, folder_id: 0}}">一覧に戻る</b-link>
        </div>
      </div>
    </ul>
    <Pagination v-if="totalPages > 1" :totalPages="totalPages" :pageIndexNo="pageIndex" @changePage="changePage"/>
    <ModalFolderMoveTo :idMove="idMove" :folder_show_id="folder_show_id" @showSuccess="open3" @showFailure="open4"  @pageIndexBack="pageIndexBack"/>
    <ModalFolderRename />
    <ModalFolderDelete @pageIndexBack="pageIndexBack"/>
    <ModalFolderDetail @pageIndexBack="pageIndexBack"/>
    <ModalFileEdit />
    <ModalFileDelete @pageIndexBack="pageIndexBack"/>
    <ModalFileOpen/>
  </div>
</template>

<script>
import ModalFolderMoveTo from '@/components/Admin/FolderManagerment/FolderMoveTo'
import ModalFolderRename from '@/components/Admin/FolderManagerment/FolderRename'
import ModalFolderDelete from '@/components/Admin/FolderManagerment/FolderDelete'
import ModalFileEdit from '@/components/Admin/FolderManagerment/FileEdit'
import ModalFileDelete from '@/components/Admin/FolderManagerment/FileDelete'
import ModalFolderDetail from '@/views/Admin/FolderManagement/FolderDetail'
import File from '@/components/Admin/FolderManagerment/File'
import ModalFileOpen from '@/views/Admin/FolderManagement/ViewFile'
import { BModal, VBModal } from 'bootstrap-vue'
import {MEDIA_TYPE} from '@/utils/constant'
import {mapState} from 'vuex'
import Pagination from '@/components/share/Pagination.vue'
export default {
  name: 'GridFile',
  data () {
    return {
      idMove: '',
      folder_show_id: '',
      parameterID: 0,
      isSearch: false
    }
  },
  components: {
    BModal,
    ModalFolderMoveTo,
    ModalFolderRename,
    ModalFolderDelete,
    ModalFolderDetail,
    ModalFileEdit,
    ModalFileDelete,
    File,
    ModalFileOpen,
    Pagination
  },
  props: {
    pageIndex: ''
  },
  methods: {
    showNoData () {
      return this.folders.length === 0 && !this.loading
    },
    open3 () {
      this.$notify({
        title: 'ファイルの移動は成功です',
        duration: 3000,
        position: 'bottom-left'
      })
    },
    open4 () {
      this.$notify({
        title: 'ファイル名が既に存在しています',
        duration: 3000,
        position: 'bottom-left',
        customClass: 'move-error'
      })
    },
    haveFolder () {
      return this.folders.length > 0
    },
    folderIsSearch () {
      return this.$route.params.folder_id !== 'search'
    },
    pageIndexBack () {
      this.$emit('pageIndexBack')
    },
    changePage (pageIndex) {
      this.$emit('changePageIndex', pageIndex)
    },
    openFolder (id, mediaType) {
      if (mediaType === MEDIA_TYPE.FOLDER_ROLE_ID) {
        this.$router.push({
          path: `/admin/companies/${this.$route.params.id}/items/${id}`,
          query: {tab: 'grid'}
        })
      } else {
        this.$store.dispatch('adminFolder/detailFile', {id: id})
        this.$root.$emit('bv::show::modal', 'modalViewFile', '#modalViewFile')
      }
    },
    showModalMoveTo (id, folderId) {
      this.idMove = id
      this.folder_show_id = folderId
      this.$store.dispatch('adminFolder/getFolderMove', {page_index: 1, id: folderId, company_id: this.$route.params.id})
      this.$root.$emit('bv::show::modal', 'modalFolderMoveTo', '#modalFolderMoveTo')
    },
    showModalDelete (id, mediaId) {
      if (mediaId === MEDIA_TYPE.FOLDER_ROLE_ID) {
        this.$store.dispatch('adminFolder/detailFolder', {id})
        this.$root.$emit('bv::show::modal', 'modalFolderDelete', '#modalFolderDelete')
      } else {
        this.$store.dispatch('adminFolder/detailFile', {id})
        this.$root.$emit('bv::show::modal', 'modalFileDelete', '#modalFileDelete')
      }
    },
    isFolder (value) {
      return value === MEDIA_TYPE.FOLDER_ROLE_ID
    },
    showModalRename (id, mediaId) {
      if (mediaId === MEDIA_TYPE.FOLDER_ROLE_ID) {
        this.$store.dispatch('adminFolder/detailFolder', {id})
        this.$root.$emit('bv::show::modal', 'modalFolderRename', '#modalFolderRename')
      } else {
        this.$store.dispatch('adminFolder/getTag', {company_id: this.$route.params.id})
        this.$store.dispatch('adminFolder/detailFile', {id: id})
        this.$root.$emit('bv::show::modal', 'modalFileEdit', '#modalFileEdit')
      }
    },
    showModalDetail (id, mediaId) {
      if (mediaId === MEDIA_TYPE.FOLDER_ROLE_ID) {
        this.$store.dispatch('adminFolder/detailFolder', {id})
        this.$root.$emit('bv::show::modal', 'modalFolderDetail', '#modalFolderDetail')
      } else {
        this.$router.push({
          path: `/admin/companies/${this.$route.params.id}/files/${id}`,
          query: {tab: this.$route.query.tab, parent: this.$route.params.folder_id}
        })
        this.$store.dispatch('adminFolder/detailFile', {id})
      }
    },
    scroll () {
      const ul = document.getElementById('data-files')
      const top = `${ul.scrollTop}px`
      const loading = document.getElementsByClassName('el-loading-mask')
      if (loading[0]) {
        loading[0].style.top = top
      }
    },
    reloadFile () {
      this.reloadFileAdmin(1)
    },
    copyFile (id) {
      this.$store.dispatch('adminFolder/copyFile', {id: id, folder_parent_id: this.$route.params.folder_id, company_id: this.$route.params.id, back: this.pageIndexBack, load: this.reloadFile})
    },
    isFile (value) {
      return value !== MEDIA_TYPE.FOLDER_ROLE_ID
    },
    isImage (value) {
      return value === MEDIA_TYPE.IMAGE_ROLE_ID
    },
    isVideo (value) {
      return value === MEDIA_TYPE.VIDEO_ROLE_ID
    },
    isImageAndVideo (value) {
      return value === MEDIA_TYPE.VIDEO_ROLE_ID || value === MEDIA_TYPE.IMAGE_ROLE_ID
    }
  },
  created () {
    this.parameterID = this.$route.params.folder_id
    if (this.parameterID === 'search') {
      this.isSearch = true
    }
  },
  watch: {
    $route (newVal, oldVal) {
      if (Object.keys(newVal.query).length === 0) {
        this.parameterID = 0
        this.isSearch = false
      } else {
        this.isSearch = true
      }
    }
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  computed: {
    ...mapState({
      folders: state => state.adminFolder.folders,
      metadata: state => state.adminFolder.metadata,
      loading: state => state.adminFolder.loading,
      totalPages: state => state.adminFolder.metadata.total_pages
    })
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/mypage/detail_mypage.scss";
  @import "@/assets/stylesheet/auth/listfile.scss";
</style>



// WEBPACK FOOTER //
// src/components/Admin/FolderManagerment/GridFiles.vue